import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {
	const sliderNetwork = {

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {
			$('.js-testimonials__slider').each(function() {
				const $slider = $(this);
				const $wrapper = $slider.closest('.testimonials');
				const $prevArrow = $wrapper.find('.testimonials__arrow--prev');
				const $nextArrow = $wrapper.find('.testimonials__arrow--next');

				const totalSlides = $slider.children().length;

				const sliderConfig = {
					slidesToShow: 3,
					slidesToScroll: 1,
					autoplay: false,
					arrows: true,
					dots: false,
					infinite: true,
					prevArrow: $prevArrow,
					nextArrow: $nextArrow,
					responsive: [
						{
							breakpoint: 991,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
							}
						}
					]
				};

				sliders.initializeSlider($slider, sliderConfig);

				const updateArrows = () => {
					const slidesToShow = $slider.slick('slickGetOption', 'slidesToShow');
					if (totalSlides <= slidesToShow) {
						$prevArrow.hide();
						$nextArrow.hide();
					} else {
						$prevArrow.show();
						$nextArrow.show();
					}
				};

				/* updateArrows(); */
				$(window).on('resize', updateArrows);
			});
		},
	};

	sliderNetwork.init();

});
